import { Banner, BannerItem, Button } from '@athena/forge';
import { getLocalizedString } from '../../utils/i18n-utils';
import athenaConfig from '../../config';

const { manageProfileClientSettings } = athenaConfig;

export default function PhoneLimitExceededBanner() {
  const bannerMessageStart = getLocalizedString('oie.phone.limit.exceeded.banner.start');
  const bannerMessageEnd = getLocalizedString('oie.phone.limit.exceeded.banner.end');

  const redirectToManageProfileLinks = (url: 'manageFactorUrl' | 'userProfileUrl') => {
    const queryParams = new URLSearchParams(window.location.search);
    const clientIdParam = queryParams.get('clientId');
    let redirectLink;
    if (clientIdParam !== null && manageProfileClientSettings[clientIdParam]) {
      redirectLink = manageProfileClientSettings[clientIdParam][url];
    }
    else {
      redirectLink = manageProfileClientSettings['default'][url];
    }
    window.location.href = redirectLink;
  };

  return <Banner alertType="critical" className="fe_u_padding--small fe_u_text-align--left">
    <BannerItem>
      {bannerMessageStart}
      <Button
        text={getLocalizedString('manage.profile.link')}
        variant="tertiary"
        className='inline-button'
        fullWidth={false}
        onClick={() => redirectToManageProfileLinks('manageFactorUrl')}
      />
      {bannerMessageEnd}
    </BannerItem>
    <BannerItem>
      <Button
        text={getLocalizedString('back.to.profile')}
        variant="tertiary"
        fullWidth={false}
        onClick={() => redirectToManageProfileLinks('userProfileUrl')}
      />
    </BannerItem>
  </Banner>;
}
